module.exports = __webpack_public_path__ + "files/SPIADI2021 - Poster.cd5ad83c860c3d9a5854b84589a10a8c.pdf";